import zh_map from './language_zh';
import en_map from './language_en';

const Language = (language, key) => language === 'zh' ? zh_map[key] : en_map[key];

export default Language;